export type NavLink = {
  label: string;
  href: string;
  external?: boolean;
  contact?: boolean;
};

export type NavGroup = {
  title: string;
  description: string;
  links: NavLink[];
};

export type NavItem = {
  label: string;
  href?: string;
  rows?: NavGroup[][];
};

export const navigation: NavItem[] = [
  {
    label: 'Solutions',
    rows: [
      [
        {
          title: 'EdTech',
          description: 'Tools for smarter learning and education',
          links: [{ label: 'Junction', href: '/success-stories/junction' }],
        },
        {
          title: 'Pharma',
          description: 'Automation for pharmaceutical operations',
          links: [{ label: 'Bayer', href: '/case-studies/bayer' }],
        },
        {
          title: 'Operations',
          description: 'Turn employee ideas into measurable results',
          links: [{ label: 'CreAction', href: '#' }],
        },
      ],
      [
        {
          title: 'Manufacturing',
          description: 'Tools to automate quoting and production',
          links: [
            { label: 'CNC Instant Quote', href: '/cnc-rfq' },
            { label: 'Pegasus Solar', href: '/case-studies/pegasus' },
            { label: 'Glide Apps', href: '#' },
          ],
        },
        {
          title: 'Recruitment',
          description: 'Automate and simplify hiring',
          links: [
            { label: 'MindPal ATS', href: '/ats' },
            { label: 'Job Matching', href: '/job-matching' },
            { label: 'Resume Generator', href: '/resume' },
            { label: 'Recruiter Pricing', href: '/pricing/recruiter' },
            { label: 'Recruiter Panel', href: '/dashboard', external: true },
          ],
        },
        {
          title: 'For Individuals',
          description: 'Get matched to the right jobs in minutes',
          links: [
            { label: 'Resume Checker', href: '/resume-checker' },
            { label: 'Bullet Points Generator', href: '/bullet-points' },
            { label: 'Resume Checker Pricing', href: '/pricing/candidate' },
            { label: 'Browse Jobs', href: '/jobs', external: true },
            { label: 'Candidate Panel', href: '/builder', external: true },
          ],
        },
      ],
    ],
  },
  {
    label: 'Clients',
    href: '/success-stories',
  },
  {
    label: 'Insights',
    rows: [
      [
        {
          title: 'Manufacturing',
          description: 'Ideas for automating production',
          links: [
            { label: 'Manufacturing Blog', href: '/manufacturing-blog' },
            { label: 'IndustryTech Webinars', href: '/webinar' },
            { label: 'MindPal Podcast', href: '#' },
          ],
        },
        {
          title: 'Careers & Hiring',
          description: 'Guides for recruiters and job seekers',
          links: [
            { label: 'Recruitment Blog', href: '/ai-company' },
            { label: 'Career Guides', href: '/career-guides' },
          ],
        },
        {
          title: 'Build Your Network',
          description: 'Events for founders, teams, curious minds',
          links: [
            { label: 'Founders Gathering', href: '#' },
            { label: 'Meetups', href: '#' },
          ],
        },
      ],
    ],
  },
  {
    label: 'Company',
    rows: [
      [
        {
          title: 'About MindPal',
          description: 'Who we are and how we work',
          links: [
            { label: 'About Us', href: '/about-us' },
            { label: 'Services', href: '/services' },
            { label: 'Press Releases', href: '/press-room' },
            { label: 'Contact', href: '#', contact: true },
          ],
        },
        {
          title: 'Legal',
          description: 'Policies, terms and compliance',
          links: [
            { label: 'Privacy Policy', href: '/privacy-policy' },
            { label: 'Cookie Policy', href: '/cookie-policy' },
            { label: 'Terms of Service', href: '/terms-of-service' },
            {
              label: 'Responsible Disclosure',
              href: '/responsible-disclosure',
            },
            { label: 'SMS Terms', href: '/sms-terms' },
          ],
        },
      ],
    ],
  },
];
